// app/javascript/modules/admissoes/defaults_api.js

export function initDefaultsApi($j, $form, h, api, opts = {}) {
  const { hide, setChecked } = h

  function applyDefaults(data) {
    if (!data || data.erro === "Condominio nao localizado") return

    // --- Assistencia Medica / Odontologica ---
    const temMedica = data.empresa_medica !== "" && data.empresa_medica != null
    const temOdonto = data.empresa_odontologica !== "" && data.empresa_odontologica != null

    if (temMedica) {
      setChecked("#params_assistencia_medica_sim", true)
    }

    if (temOdonto) {
      setChecked("#params_assistencia_odontologica_sim", true)
    }

    // Se nao tem NENHUM plano de saude, esconde a secao inteira de Saude
    if (!temMedica && !temOdonto) {
      const $saudeSection = $form.find("#secao-saude")
      if ($saudeSection.length) {
        hide($saudeSection)
      }
    }

    // --- Contrato de experiencia ---
    const $select = $form.find("#params_contrato_experiencia")
    if ($select.length) {
      let optionExists = false

      $select.find("option").each(function () {
        if ($j(this).val() === data.contrato_experiencia) {
          optionExists = true
          $j(this).text(`${data.contrato_experiencia} (opcao padrao)`)
          return false
        }
      })

      if (!optionExists && data.contrato_experiencia) {
        $select.append(`<option value="${data.contrato_experiencia}">${data.contrato_experiencia} (opcao padrao)</option>`)
      }

      if (data.contrato_experiencia) $select.val(data.contrato_experiencia)
    }

    // --- Vale Alimentacao / Vale Transporte ---
    if (data.possui_va === "N") {
      hide($form.find(".params_ticket_alimentacao"))
      hide($form.find(".params_ticket_refeicao"))
      hide($form.find(".params_valor_ticket_alimentacao"))
      hide($form.find(".params_valor_ticket_refeicao"))
      hide($form.find(".params_desconta_em_contracheque"))
      hide($form.find(".params_tipo_desconto_contracheque"))
      hide($form.find(".params_desconto_em_contracheque"))

      // Esconde a secao inteira de Tickets e Descontos
      const $ticketSection = $form.find("#secao-tickets-descontos")
      if ($ticketSection.length) hide($ticketSection)
    }

    if (data.possui_vt === "N") {
      hide($form.find(".params_meio_de_transporte_ida"))
      hide($form.find("#adicionar_campo_meio_de_transporte_ida"))
      hide($form.find(".params_valor_meio_de_transporte_ida"))
      hide($form.find("#adicionar_campo_meio_de_transporte_volta"))
      hide($form.find(".params_valor_meio_de_transporte_volta"))
      hide($form.find("#adicionarCampoIda"))
      hide($form.find(".params_meio_de_transporte_volta"))
      hide($form.find(".params_meio_de_transporte_volta_valor"))
      hide($form.find("#adicionarCampoVolta"))
      hide($form.find(".params_possui_vale_transporte"))
      hide($form.find(".possui_cartao_bilhete_unico"))
      hide($form.find(".esta_desvinculado_da_empresa_anterior"))
      hide($form.find(".entrar_em_contato_antiga_empresa"))
      hide($form.find(".numero_cartao_vale_transporte"))
    }

    if (
      data.valor_vale_alimentacao != null &&
      data.valor_vale_alimentacao !== "0,00" &&
      data.valor_vale_alimentacao !== ""
    ) {
      $form.find("#params_valor_ticket_refeicao").val(data.valor_vale_alimentacao)
    }
  }

  function fetch() {
    if (!api.defaultsUrl) return
    $j.ajax({
      url: api.defaultsUrl,
      type: "GET",
      success: (data) => {
        applyDefaults(data)
        if (opts.afterApply) opts.afterApply()
      },
      error: (_jqXHR, textStatus, errorThrown) => {
        console.error("AJAX request failed:", textStatus, errorThrown)
      },
    })
  }

  fetch()
  return { destroy() { } }
}
